import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('crm_token');
    const savedCompany = localStorage.getItem('crm_company');
    
    if (token && savedCompany) {
      try {
        setCompany(JSON.parse(savedCompany));
      } catch {
        logout();
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    const { token, company: companyData } = res.data.data;
    localStorage.setItem('crm_token', token);
    localStorage.setItem('crm_company', JSON.stringify(companyData));
    setCompany(companyData);
    return res.data;
  };

  const signup = async (name, email, password) => {
    const res = await API.post('/auth/signup', { name, email, password });
    const { token, company: companyData } = res.data.data;
    localStorage.setItem('crm_token', token);
    localStorage.setItem('crm_company', JSON.stringify(companyData));
    setCompany(companyData);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('crm_token');
    localStorage.removeItem('crm_company');
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ company, loading, login, signup, logout, isAuthenticated: !!company }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};